export default __webpack_public_path__ + "static/media/dancing-script-latin-400.27fff105.woff2";